import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import Table from '@/components/base/Table';
import Icon from '@/components/base/Icon';
import useLanguage from '@/hooks/useLanguage';
import Linker from '@/components/base/Linker';
import clzz from 'classnames';
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function SimpleTable(props) {
    var translate = useLanguage().translate;
    var _ref = props || {}, _rowKey = _ref.rowKey, rowKey = _rowKey === void 0 ? 'key' : _rowKey, _title = _ref.title, title = _title === void 0 ? '' : _title, banner = _ref.banner, onRefresh = _ref.onRefresh, moreHref = _ref.moreHref, _showHeader = _ref.showHeader, showHeader = _showHeader === void 0 ? true : _showHeader, _className = _ref.className, className = _className === void 0 ? '' : _className, style = _ref.style, loading = _ref.loading, rest = _objectWithoutProperties(_ref, [
        "rowKey",
        "title",
        "banner",
        "onRefresh",
        "moreHref",
        "showHeader",
        "className",
        "style",
        "loading"
    ]); // const handleClickRefresh = useCallback(() => {
    //   onRefresh && onRefresh()
    // }, [onRefresh])
    return(/*#__PURE__*/ _jsxs("div", {
        className: className,
        style: style,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: clzz({
                    hidden: !showHeader
                }, 'h-[34px] pb-[12px] sticky top-0 bg-base z-10'),
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "text-base text-[18px] leading-[22px] font-semibold flex items-center",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "",
                                children: title
                            }),
                            banner
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Linker, {
                        className: "absolute top-[2px] right-[10px] flex items-center leading-[20px] text-[15px] font-[400]",
                        href: moreHref || '',
                        children: [
                            translate('view more'),
                            /*#__PURE__*/ _jsx(Icon, {
                                type: "arrow-right",
                                className: "text-primary text-[16px]"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Table, _objectSpread({
                layoutClassName: "h-[calc(100%_-_40px)] overflow-y-auto",
                rowKey: rowKey,
                hideColumns: true,
                loading: loading,
                skeletonRows: 18
            }, rest))
        ]
    }));
}
export default SimpleTable;
